// const currentAuth = ["admin"];
// const currentAuth = ["guest"];
// currentAuth='';
// export { currentAuth };
export function getAuthority(str) {
  // return localStorage.getItem('bb_authority') || ['admin', 'user'];
  const authorityString =
    typeof str === "undefined"
      ? localStorage.getItem("bb_authority")
      : str;
  // authorityString could be admin, "admin", ["admin"]
  console.log('authorityString',authorityString,str,localStorage.getItem("bb_authority"))
  let authority;
  try {
    authority = JSON.parse(authorityString);
  } catch (e) {
    authority = authorityString;
  }
  if (typeof authority === "string") {
    return [authority];
  }
  return authority;
}
export function setAuthority(authority) {
  const proAuthority = typeof authority === "string" ? [authority] : authority;
  return localStorage.setItem(
    "bb_authority",
    JSON.stringify(proAuthority)
  );
}
export function getCurrentAuthority() {
  // return currentAuth;
  console.log("getAuthority()",getAuthority());
  return getAuthority();
}

export function check(authority) {
  const current = getCurrentAuthority();
  if(current){
    console.log("check-authority",current,current.some(item => authority.includes(item)),authority);
    return current.some(item => authority.includes(item))
  }
  return null;
}

export function isLogin() {
  const current = getCurrentAuthority();
  // console.log("当前current",current)
  return current && current[0] !== "guest";
}
